/**
 * Module commun bdc
 * @module app.bdc.cpi
 */
define(['angular', 'modules/bdc/cpi/controllers/cpiCtrl', 'modules/bdc/cpi/factories/cpiService'], function(angular) {


    /**
     * Configure routing
     * @param $routeProvider
     */
    function cpiRouter($routeProvider) {
        $routeProvider.when('/bdc/cpi', {
            templateUrl: 'bdc/cpi/partials/cpi.html',
            controller: 'CPICtrl',
            controllerAs: 'cpiCtrl',
            params: {
                menuTitle: 'CPI'
            }
        });
    }

    cpiRouter.$inject = ['$routeProvider'];

    angular.module('app.bdc.cpi', ['app.bdc.cpi.cpiCtrl', 'app.bdc.cpi.cpiService']).config(cpiRouter);
});
